import { combineStateReducer } from "../utils/combineStateReducer";
import { State, Selector } from "./types";

import * as submitMessage from "./submitMessage";
import * as retrieveConversations from "./retrieveConversations";
import * as getConversationMessages from "./getConversationMessages";
import * as deleteConversation from "./deleteConversation";
import * as cancelJob from "./cancelJob";
import * as resetMemory from "./resetMemory";

const initialState: State = {
  submitMessage: submitMessage.initialState,
  retrieveConversations: retrieveConversations.initialState,
  getConversationMessages: getConversationMessages.initialState,
  deleteConversation: deleteConversation.initialState,
  cancelJob: cancelJob.initialState,
  resetMemory: resetMemory.initialState,
};

const reduceState = combineStateReducer(initialState, {
  submitMessage: submitMessage.reduceState,
  retrieveConversations: retrieveConversations.reduceState,
  getConversationMessages: getConversationMessages.reduceState,
  deleteConversation: deleteConversation.reduceState,
  cancelJob: cancelJob.reduceState,
  resetMemory: resetMemory.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...submitMessage.createSelector(() => getState().submitMessage),
    ...retrieveConversations.createSelector(
      () => getState().retrieveConversations,
    ),
    ...getConversationMessages.createSelector(
      () => getState().getConversationMessages,
    ),
    ...deleteConversation.createSelector(() => getState().deleteConversation),
    ...cancelJob.createSelector(() => getState().cancelJob),
    ...resetMemory.createSelector(() => getState().resetMemory),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
